import {Component, Input, OnDestroy, ViewChild} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Subject} from 'rxjs';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastService} from '../../toast/toast.service';
import {PaymentFormComponent} from '../../payment-form/payment-form.component';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-add-payment-method-modal',
  imports: [
    FormsModule,
    PaymentFormComponent,
    NgIf
  ],
  templateUrl: './add-payment-method-modal.component.html',
  styleUrl: './add-payment-method-modal.component.scss'
})
export class AddPaymentMethodModalComponent implements OnDestroy {
  onDestroy$ = new Subject<boolean>();

  @Input() companyId: string | null = null

  // Payment form
  @ViewChild(PaymentFormComponent) paymentForm!: PaymentFormComponent;
  paymentValid = false;

  submitted = false;

  constructor(private modal: NgbActiveModal,
              private toast: ToastService) {
  }

  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  submit() {
    if (!this.paymentValid) {
      this.toast.failure("Please enter a valid payment method")
      return;
    }

    this.submitted = true
    this.paymentForm
      .onCreateOrRetrieveWallet()
      .then(() => {
        this.toast.success('Your payment method has been added.');
        this.submitted = false;
        this.close()
      })
      .catch(error => {
        this.toast.failure(error);
        this.submitted = false;
      });
  }

  close() {
    this.modal.close()
  }

  onPaymentValid(paymentValid: boolean) {
    this.paymentValid = paymentValid
  }

}
